const Styles = {
  containerStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#f4f4f8',
    flexDirection: 'column'
  },
  header: {
    color: '#e57373'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/other/NotFound/styles.js